/* parseQuery(http://localhost:8080/?dump&test) => {dump:'', test: ''} */
export default (queryString) => {
  var query = {};
  var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return query;
}



// WEBPACK FOOTER //
// ./src/helpers/get-query-var.js